import src from "IMAGE";
export default { src, width: 784, height: 1168, blurWidth: 5, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAYAAAAx8TU7AAAAM0lEQVR42q2OMQoAMAwCpYZo///hNkMhQ8ccCKKDYtuKCD5ZTpRBg+TC7efD31BdYENSHnhrAV8rA1RLAAAAAElFTkSuQmCC"};
